import apiClient from './client';

export const listAnnouncements = (params) => apiClient.get('/announcements', { params }).then((r) => r.data);
export const createAnnouncement = (payload) => apiClient.post('/announcements', payload).then((r) => r.data);
export const updateAnnouncement = (id, payload) => apiClient.put(`/announcements/${id}`, payload).then((r) => r.data);
export const deleteAnnouncement = (id) => apiClient.delete(`/announcements/${id}`).then((r) => r.data);
